import { OperacaoEnum } from "core/resources/enums/conta";

export interface PrevisaoOrcamentariaCategoria {
  id: string;
  nome: string;
  valores: (number | string)[];
}

export enum PrevisaoOrcamentariaPeriodo {
  Mensal = "monthy",
  Diario = "daily",
  Trimestral = "quarterly",
  Bimestral = "bimonthly",
  Semestral = "semester",
  Anual = "yearly",
}
export interface PrevisaoOrcamentariaColuna {
  nome: string;
  fixa: boolean;
}
export interface PrevisaoOrcamentariaDados {
  categorias: PrevisaoOrcamentariaCategoria[];
  colunas: PrevisaoOrcamentariaColuna[];
  saldoAtual: number[];
}

export interface PrevisaoOrcamentariaParams {
  dataInicio?: string;
  dataFim?: string;
  operacao?: OperacaoEnum;
  tenantId?: string;
  type?: PrevisaoOrcamentariaPeriodo;
  orderDirection?: string;
  orderBy?: string;
  search?: string;
}

export interface PrevisaoOrcamentariaForm {
  id: string;
  createdAt: string;
  ano: string;
  nome: string;
  taxaInadimplenciaPrevista: number;
  valorArrecadacao: number;
  tipoArrecadacaoId: string;
}

export interface PrevisaoOrcamentrariaParametros {
  indiceMedioInadimplencia: number;
}

export interface PrevisaoOrcamentariaSaveRequest
  extends Omit<PrevisaoOrcamentariaForm, "ano"> {
  dataFim: string;
  dataInicio: string;
}

export interface PrevisaoOrcamentaria {
  id: string;
  createdAt: string;
  dataFim: string;
  dataInicio: string;
  nome: string;
  taxaInadimplenciaPrevista: number;
  valorArrecadacao: number;
  tipoArrecadacaoId: string;
  previsao: {
    despesa: number;
    receita: number;
  };
}

export interface PrevisaoOrcamentariaLancamento {
  valor?: number;
  categoriaFinanceiraId?: string | undefined;
  mesInicio?: string;
  mesFim?: string;
  formaDistribuicao?: FormaDistribuicaoLancamento;
  operacao?: OperacaoEnum;
}

export interface RequestAtualizarLancamentoMes {
  valor?: number;
  categoriaFinanceiraId?: string | undefined;
}

export enum FormaDistribuicaoLancamento {
  IgualTodosMeses = "igual",
  DivididoEntreMeses = "dividido",
}

export interface PlanejamentoOrcamentarioDetalheResponse {
  id: string;
  nome: string;
  dataInicio: string;
  dataFim: string;
  createdAt: string;
  despesas: PlanejamentoOrcamentarioDetalheItemResponse[];
  receitas: PlanejamentoOrcamentarioDetalheItemResponse[];
}

export interface FiltroPrevisaoOrcamentaria {
  mes?: string;
  media?: "1";
  categoriasFinanceirasIds?: string[];
  centrosDeCustoIds?: string[];
}

export interface PlanejamentoOrcamentarioDetalheItemResponse {
  id: string;
  categoriaFinanceiraPaiId: string;
  nome: string;
  breadcrumb: string;
  previsto: number;
  ordem: number;
  items: PlanejamentoOrcamentarioDetalheItemResponse[];
  previstoItems?: number;
}

export interface ImportarPlanilhaPrevisaoOrcamentariaItem {
  mes: string;
  valor: number;
  categoria: string;
}

export interface ImportarPlanilhaPrevisaoOrcamentariaRequest {
  substituirLancamentos: boolean;
  items: ImportarPlanilhaPrevisaoOrcamentariaItem[];
}
